define.alias("shared/modifiers/autofocus", "calendar/modifiers/autofocus");